import React, { Suspense, lazy } from 'react';
import tenantConstants from '@constants';
import Cookies from 'js-cookie';
import LegacyListings from './listings';

// Loaded only when the cookie is set, so the legacy page never pulls in any Listings V2 code.
const MyListingsV2 = lazy(() => import('./MyListings'));

/**
 * The single switch between the legacy My Listings page and the Listings V2 redesign (desktop and
 * mobile). V2 renders only when the `tenantConstants.LISTINGS_V2_COOKIE` cookie is set; without it
 * the legacy page renders. No route change, and no shared or legacy component carries any V2 code.
 */
const ListingsPageGate = (props) => {
  if (!Cookies.get(tenantConstants.LISTINGS_V2_COOKIE)) {
    return <LegacyListings {...props} />;
  }
  return (
    <Suspense fallback={null}>
      <MyListingsV2 {...props} />
    </Suspense>
  );
};

export default ListingsPageGate;
